<template>
  <div>
    <canvas ref="canvas" style="max-width: 420px; height: 250px;"></canvas>
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs'

export default {
  name: 'PieChart',
  extends: Pie,
  props: {
    chartData: {
      type: Object,
      required: true
    }, 
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false
      })
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: {
      deep: true,
      handler (newData) {
        const options = JSON.parse(JSON.stringify(this.options))
        options.tooltips = {
        callbacks: {
          label: (tooltipItem, data) => {
            const dataset = data.datasets[tooltipItem.datasetIndex]
            const total = dataset.data.reduce((sum, val) => sum + val, 0)
            const value = dataset.data[tooltipItem.index]
            const pct = ((value / total) * 100).toFixed(1)
            const label = data.labels[tooltipItem.index]
            return `${label}: ${pct}%`
          }
        }
      }
        this.renderChart(newData, options)
      }
    }
  },
 
}
</script>
